<template>
  <div id="addEdit">
    <el-dialog :title="formData.category_id?'编辑分类':'添加分类'" :visible.sync="visible" width="600px">

      <el-form :model="formData" :rules="rules" ref="form"  label-width="100px" class="demo-ruleForm" size="small">
        <el-form-item prop="name" label="分类名称">
          <el-input v-model="formData.name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="未选中图片" prop="image.file_id" :rules="[{ required: true, message: '请上传未选中图片', trigger: 'change' }]">
          <el-button type="primary" @click="isupload=true;type='image'">选择图片</el-button>
          <div v-if="formData.image.file_id" class="img">
            <img :src="formData.image.file_path" width="100" height="100" />
          </div>
        </el-form-item>
        <el-form-item label="选中图片" prop="selectedImage.file_id" :rules="[{ required: true, message: '请上传选中图片', trigger: 'change' }]">
          <el-button type="primary" @click="isupload=true;type='selectedImage'">选择图片</el-button>
          <div v-if="formData.selectedImage.file_id" class="img">
            <img :src="formData.selectedImage.file_path" width="100" height="100" />
          </div>
        </el-form-item>
        <el-form-item prop="sort" label="排序">
          <el-input v-model.number="formData.sort" placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submitSave" :loading="loading">确定</el-button>
      </div>

    </el-dialog>

    <Upload v-if="isupload" :isupload="isupload" @returnImgs="uploadChange">上传图片</Upload>


  </div>
  </template>

  <script>
  import SecondhandApi from '@/api/secondhand'
  import Upload from '@/components/file/Upload';
  export default {
    components:{Upload},
    data(){
      return{
        loading:false,
        visible:false,
        isupload:false,
        type:'',
        formData:{
          name:'',
          image:{},
          selectedImage:{},
          sort:1,
        },
        rules: {
          name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
          sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        },
      }
    },
    methods:{

      /*提交保存*/
      submitSave(){
        let params = JSON.parse(JSON.stringify(this.formData));
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true;
            if(params.image){
              params.image_id=params.image.file_id
            }
            let API=this.formData.category_id?'setCategoryEdit':'categoryAdd'
            SecondhandApi[API](params).then(data => {
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.visible=false
              this.$emit('refresh')
            }).finally(() => {
              this.loading = false;
            });
          }
        });
      },

      /*显示弹窗*/
      show(e){
        this.visible=true
        this.formData.category_id=null
        this.$nextTick(()=>{
          this.$refs.form.resetFields()
          if(e&&e!=''){
            this.formData.category_id=e.category_id
            for(let i in this.formData){
              if(e[i]){
                this.formData[i]=e[i]
              }
            }
          }
        })
      },

      // 图片选择
      uploadChange(e){
        // console.log(e);
        if(e&&e!=''){
          this.formData[this.type]=e[0];
        }
        this.isupload=false
      },

    },

  }
  </script>

  <style lang="scss" scoped>
  .img{margin-top: 10px;}
  </style>


// WEBPACK FOOTER //
// src/views/secondhand/category/addEdit.vue